'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (text) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _configs2.default.defaults;

  if (!text) {
    return 'empty';
  }

  var mergedOptions = Object.assign({}, _configs2.default.defaults, options);
  var maxLength = mergedOptions.maxWeightedTweetLength;

  // Determine max length independent of URL length
  if ((0, _getTweetLength2.default)(text, mergedOptions) > maxLength) {
    return 'too_long';
  }

  if ((0, _hasInvalidCharacters2.default)(text)) {
    return 'invalid_characters';
  }

  return false;
};

var _configs = require('./configs');

var _configs2 = _interopRequireDefault(_configs);

var _getTweetLength = require('./getTweetLength');

var _getTweetLength2 = _interopRequireDefault(_getTweetLength);

var _hasInvalidCharacters = require('./hasInvalidCharacters');

var _hasInvalidCharacters2 = _interopRequireDefault(_hasInvalidCharacters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];